<template>
  <div class="modal" :class="{ 'is-active': shown }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"></p>
        <button class="btn spaceless isGray isCollapsed" @click="closeSelf()">
          <icon type="x" size="16"/>
        </button>
      </header>
      <section class="modal-card-body" v-if="meta">
        <p>
          Opravdu chcete uživateli
          <strong>{{ meta.user.first_name }} {{ meta.user.last_name }}</strong>
          {{ meta.enable ? 'povolit' : 'odepřít' }} přístup k aplikaci?
        </p>
      </section>

      <footer class="modal-card-foot">
        <div class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <div class="level-item">
              <button class="btn spaceless isGreen" @click="validate()">
                <icon type="check" size="16"/>Ano
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: ['shown', 'meta'],

  methods: {
    closeSelf() {
      this.$emit('closeSelf');
    },

    validate() {
      this.$emit('validated');
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/buttons.sass'

.modal-card-title
  margin-bottom: 0 !important

.modal-card-foot .level
  width: 100%

.modal-card-body
  text-align: center

</style>
